export default "__VITE_ASSET__epKeL6Bo__"